import { render, staticRenderFns } from "./wmsLocation.vue?vue&type=template&id=634cf4a0&scoped=true"
import script from "./wmsLocation.vue?vue&type=script&lang=js"
export * from "./wmsLocation.vue?vue&type=script&lang=js"
import style0 from "./wmsLocation.vue?vue&type=style&index=0&id=634cf4a0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634cf4a0",
  null
  
)

export default component.exports